import React from 'react';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';
import { MainView, NoAccessView } from '@repo/ui/Views';
import BrandsTable from '../components/BrandsTable';
import { useAccount } from '@/hooks/useAccount';

const Brands = () => {
  const user = useUser();

  const account = useAccount();
  const accountId = account.id;

  return POLICIES['csp_brands:index'](user) ? (
    <MainView title="TCR Brands">
      <BrandsTable accountId={Array.isArray(accountId) ? accountId[0] : accountId} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Brands;
